<template>
  <Modal
    :modal-types="[COMING_SOON_MODAL]"
    font-awesome-icon-class="far fa-fw fa-star-shooting fa-rotate-180"
    modal-title="Coming Soon!"
  >
    <div class="coming-soon-modal-container">
      <div class="coming-soon-ui-container">
        <div class="coming-soon-icon">
          <i class="far fa-fw fa-star-shooting fa-rotate-180"></i>
        </div>
        <h2 class="coming-soon-header">Coming&nbsp;Soon!</h2>
        <p class="coming-soon-message">We'll have more to show you in this part of the new SharpCharts Workbench very&nbsp;soon</p>
      </div>
      <hr class="sc3-form-divider" />
      <button
        type="button"
        class="sc3-button sc3-button-green"
        @click="closeModal()"
      >
        <i class="fas fa-fw fa-check-circle"></i>
        &nbsp;OK!
      </button>
    </div>
  </Modal>
</template>

<script lang="ts" setup>
  import { useModals } from '@/composables/useModals';
  import Modal from '@/components/modals/Modal.vue';

  const {
    COMING_SOON_MODAL,
    closeModal
  } = useModals();
</script>

<style scoped>
  .coming-soon-modal-container {
    text-align: center;
  }

  .coming-soon-ui-container {
    margin: 10px;
    padding: 12px 18px;
    background-color: #f2f5f7;
    border-radius: 10px;
    text-align: center;
  }

  .coming-soon-icon {
    line-height: 2;
    font-size: 45px;
    color: #f9690e;
  }

  .coming-soon-header {
    color: #333;
    margin: 0px 0px 30px 0px;
    line-height: 1.25;
    font-family: 'Roboto Condensed', 'Lato', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    font-size: 30px;
    font-weight: bold;
  }

  .coming-soon-message {
    margin: 0px 0px 15px 0px;
    line-height: 1.4;
    font-size: 16px;
    font-weight: normal;
    color: #5a6672;
  }
</style>
